import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { GroundingMenuSearchBoxSlots, GroundingMenuSearchBoxState } from './GroundingMenuSearchBox.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const groundingMenuSearchBoxClassNames: SlotClassNames<GroundingMenuSearchBoxSlots> = {
  root: 'fai-GroundingMenuSearchBox',
  expandButton: 'fai-GroundingMenuSearchBox__expandButton',
  searchBox: 'fai-GroundingMenuSearchBox__searchBox',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  searchBox: {
    borderRadius: tokens.borderRadiusCircular,
    borderBottomColor: tokens.colorNeutralStroke1,
    ':after': {
      left: tokens.spacingHorizontalS,
      right: tokens.spacingHorizontalS,
    },
    ':hover': { borderBottomColor: tokens.colorNeutralStroke1Hover },
    // DO NOT add a space between the selectors! It changes the behavior of make-styles.
    // https://github.com/microsoft/fluentui/blob/master/packages/react-components/react-input/library/src/components/Input/useInputStyles.styles.ts
    ':active,:focus-within': {
      borderBottomColor: tokens.colorNeutralStroke1Pressed,
    },
  },
  collapsed: {
    height: '1px',
    width: '1px',
    position: 'absolute',
    clip: 'rect(0px, 0px, 0px, 0px)',
  },
});

/**
 * Apply styling to the GroundingMenuSearchBox slots based on the state
 */
export const useGroundingMenuSearchBoxStyles_unstable = (
  state: GroundingMenuSearchBoxState,
): GroundingMenuSearchBoxState => {
  'use no memo';

  const { expanded } = state;

  const styles = useStyles();
  state.root.className = mergeClasses(groundingMenuSearchBoxClassNames.root, state.root.className);

  if (state.expandButton) {
    state.expandButton.className = mergeClasses(
      groundingMenuSearchBoxClassNames.expandButton,
      expanded && styles.collapsed,
      state.expandButton.className,
    );
  }

  if (state.searchBox) {
    state.searchBox.className = mergeClasses(
      groundingMenuSearchBoxClassNames.searchBox,
      styles.searchBox,
      !expanded && styles.collapsed,
      state.searchBox.className,
    );
  }

  return state;
};
